import styled from 'styled-components'
import { ContainerSombra } from '../ContainerSombra'

export const informacaoParceiroStyles = {
  Container: styled(ContainerSombra)`
    padding: 16px;
  `
}
